import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { useEffect } from "react";

// Pages
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ProblemPage from "@/pages/ProblemPage";
import SolutionPage from "@/pages/SolutionPage";
import CorporateCSIPage from "@/pages/CorporateCSIPage";
import ForRidersPage from "@/pages/ForRidersPage";
import AdvertisingPage from "@/pages/AdvertisingPage";
import ImpactPage from "@/pages/ImpactPage";
import InsightsPage from "@/pages/InsightsPage";
import BlogPostPage from "@/pages/BlogPostPage";
import ContactPage from "@/pages/ContactPage";
import AdminLoginPage from "@/pages/admin/AdminLoginPage";
import AdminDashboard from "@/pages/admin/AdminDashboard";

// Components
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

// Simple analytics tracker (inline to avoid useLocation issues)
const AnalyticsTracker = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Track page views
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: location.pathname,
      });
    }
    if (window.fbq) {
      window.fbq('track', 'PageView');
    }
  }, [location]);
  
  return null;
};

// Scroll to top on route change
const ScrollToTop = () => {
  const location = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  
  return null;
};

const AppContent = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  
  return (
    <>
      <ScrollToTop />
      <AnalyticsTracker />
      {!isAdminRoute && <Navigation />}
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/problem" element={<ProblemPage />} />
          <Route path="/solution" element={<SolutionPage />} />
          <Route path="/corporate-csi" element={<CorporateCSIPage />} />
          <Route path="/for-riders" element={<ForRidersPage />} />
          <Route path="/advertising" element={<AdvertisingPage />} />
          <Route path="/impact" element={<ImpactPage />} />
          <Route path="/insights" element={<InsightsPage />} />
          <Route path="/insights/:slug" element={<BlogPostPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin/*" element={<AdminDashboard />} />
        </Routes>
      </main>
      {!isAdminRoute && <Footer />}
      {!isAdminRoute && <WhatsAppButton />}
      <Toaster position="top-right" richColors />
    </>
  );
};

function App() {
  return (
    <div className="App min-h-screen bg-white">
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </div>
  );
}

export default App;
